import React from "react";

const CustomerReviews = () => {
    const reviews = [
        {
            name: "Saugat Adhikari",
            review: "Found a reliable plumber within minutes. Really impressed!",
            img: "https://i.pravatar.cc/100?img=11",
        },
        {
            name: "Asmita Khadka",
            review: "Very smooth experience. Booking a service was super easy.",
            img: "https://i.pravatar.cc/100?img=25",
        },
        {
            name: "Prabin Gautam",
            review: "Electrician arrived on time and fixed everything quickly.",
            img: "https://i.pravatar.cc/100?img=36",
        },
        {
            name: "Ritu Basnet",
            review: "Helpful platform! Found nearby services instantly.",
            img: "https://i.pravatar.cc/100?img=14",
        },
        {
            name: "Sanjay Koirala",
            review: "Great for comparing service providers. Very useful for daily needs.",
            img: "https://i.pravatar.cc/100?img=48",
        },
        {
            name: "Nikita Shrestha",
            review: "Fast response and very friendly support team. Loved it!",
            img: "https://i.pravatar.cc/100?img=22",
        },
    ];


    return (
        <div className="container my-5">
            <h2 className="fw-bold text-center mb-4">Customer Reviews</h2>

            <div
                id="multiCarousel"
                className="carousel slide"
                data-bs-ride="carousel"
                data-bs-interval="3000"
            >
                <div className="carousel-inner">

                    {reviews.map((review, index) => (
                        <div
                            key={index}
                            className={`carousel-item ${index === 0 ? "active" : ""}`}
                        >
                            <div className="row">
                                {[0, 1, 2].map((i) => {
                                    const item = reviews[(index + i) % reviews.length];
                                    return (
                                        <div className="col-md-4" key={i}>
                                            <div className="card review-card p-3 text-center">
                                                <img
                                                    src={item.img}
                                                    className="rounded-circle mx-auto"
                                                    width="70"
                                                    height="70"
                                                    alt="User"
                                                />
                                                <h6 className="fw-bold mt-3">{item.name}</h6>
                                                <p className="text-warning small mb-1">★★★★★</p>
                                                <p className="text-muted">{item.review}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}

                </div>

                {/* Controls */}
                <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#multiCarousel"
                    data-bs-slide="prev"
                >
                    <span className="carousel-control-prev-icon"></span>
                </button>

                <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#multiCarousel"
                    data-bs-slide="next"
                >
                    <span className="carousel-control-next-icon"></span>
                </button>
            </div>

            <style>
                {`
                .review-card {
                    border: 1.5px solid #d3d3d3 !important;
                    border-radius: 15px;
                    background: #fff;
                    transition: 0.3s;
                }
                .review-card:hover {
                    transform: translateY(-6px);
                    box-shadow: 0 12px 28px rgba(0,0,0,0.15);
                    border-color: #b5b5b5 !important;
                }
                `}
            </style>
        </div>
    );
};

export default CustomerReviews;
